import React from 'react';
import PaylixLogoDark from "../../../../../../assets/images/paylix_logo_big_black.svg";
import PaylixLogoWhite from "../../../../../../assets/images/paylix_logo_big_white.svg";
import useTheme from "../../../../../../hooks/useTheme";


const General = () => {

  const isDark = useTheme();

  return (
    <div className="customization-docs-screen ">
      <div className="customization-docs-screen-body">

        <div className="customization-docs-screen-img">
          <img style={{ width: 130, margin: "1rem 0" }} src={isDark ? PaylixLogoWhite : PaylixLogoDark} alt="Paylix Logo"/>
        </div>

        <div style={{ fontSize: "1rem", marginBottom: "1rem", fontWeight: 500 }}>
          Customization by Paylix is a feature-packed theme builder powering the storefronts of tomorrow.
        </div>

        <div>
          From the Paylix dashboard, entrepreneurs are able to reimagine their storefronts from the ground up. This includes customization support from the header to the footer and everything in between. This includes fonts, colors, domains, and sizing so entrepreneurs can get back to doing what they're best at.
        </div><br/>

        <div>
          This is our temporary documentation for businesses in our BETA for customization. Your experience will ultimately help us build an even grander editor for every entrepreneur on Paylix.
        </div>

      </div>
    </div>
  );
};

export default General;
